import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './AthleteUserCredentialsSelectionValidation';

import NavLinks from '../../../meet/NavLinks';
import EntryNavLinks from '../../EntryNavLinks';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useCredentialTypeData from '../../../../state/credentialType/UseCredentialTypeData';
import useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData from '../../../../state/omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntry/UseOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData';
import useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData from '../../../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData';
import useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData from '../../../../state/omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection/UseOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData';

import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import UseForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_FORM_STATE = {
  credentialTypeId: Constants.DEFAULT_ID,
  credentialTypeName: '',
  massageTypeName: '',
  isInGoodStanding: true,
  firstOrPreferredName: '',
  lastName: '',
  memberId: '',
  email: ''
};

const useAthleteUserCredentialsSelection = () => {
  const navigate = useNavigate();
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState } = useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData();
  const { omeMeetOrgUnitAthleteEntryIndividualRosterEntryState } = useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData();
  const { omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState, clearOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionArrayData,
    getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection, postOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection } = useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionData();
  const { credentialTypeState } = useCredentialTypeData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const [state, setState] = useState({
    initialStateHandled: false,
    isInitialLoadComplete: false, tryFilter: false, tryRedirect: false,
    currentFilterResultsCredentialTypeId: Constants.DEFAULT_ID, currentFilterResultsCredentialTypeName: ''
  });
  const [gridState, setGridState] = useState({ gridData: [] });
  const [selectionChangesState, setSelectionChangesState] = useState({ arrayData: [] });
  const { handleSubmit, formState, errorState, setErrors, setFormState, onFormValueChanged, onValueTextPairChanged } = UseForm(INITIAL_FORM_STATE, submitFormCallback, validate);
  const { environmentVariableState, CREDENTIAL_TYPE_NAME_MASSAGE } = useEnvironmentVariableData();

  const onFilterClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    handleSubmit();
  }

  const onClearFilterClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (state.currentFilterResultsCredentialTypeId !== credentialTypeState.dataAsOptionsWithNames[1]?.id) {
      setSelectionChangesState({ ...selectionChangesState, arrayData: [] });
    }
    let newFormState = {
      ...INITIAL_FORM_STATE,
      credentialTypeId: credentialTypeState.dataAsOptionsWithNames[1]?.id || Constants.DEFAULT_ID,
      credentialTypeName: credentialTypeState.dataAsOptionsWithNames[1]?.name || '',
      massageTypeName: CREDENTIAL_TYPE_NAME_MASSAGE || ''
    }
    setFormState(newFormState);
    setState({ ...state, currentFilterResultsCredentialTypeId: newFormState.credentialTypeId, currentFilterResultsCredentialTypeName: newFormState.credentialTypeName });
    getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.orgUnitAthleteEntryId, createFilterObj(newFormState));
    setErrors({});
  }

  const onSaveClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    let deleteAfterPayment = false;
    if (omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.status !== Constants.WORKFLOW_STATUS_SUBMITTED) {
      for (let i = 0; i < selectionChangesState.arrayData.length; i++) {
        if (selectionChangesState.arrayData[i].orgUnitAthleteEntryOrgUnitNonAthleteEntryId !== null && selectionChangesState.arrayData[i].isSelected === false &&
          selectionChangesState.arrayData[i].hasPaid === true) {
          deleteAfterPayment = true;
        }
      }
    }

    if (deleteAfterPayment === true) {
      setErrors({ ...errorState, general: `The current selections removed a paid credential. Removing a credential that has been purchased is not allowed.` });
    }
    else {
      let deckPassRuleError = false;
      //Compare maxCredentialNumber to number of selections
      if (omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber !== undefined &&
        omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber !== null &&
        omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber >= 0) {
        let existingCredentialNum = omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.arrayData?.length;
        let newSelectionsArray = selectionChangesState.arrayData?.filter(x => (x.isSelected === true && x.orgUnitAthleteEntryOrgUnitNonAthleteEntryId === null));
        let newSelectionsNum = newSelectionsArray ? newSelectionsArray.length : 0;
        let newUnselectionsArray = selectionChangesState.arrayData?.filter(x => (x.isSelected === false && x.orgUnitAthleteEntryOrgUnitNonAthleteEntryId !== null));
        let newUnselectionsNum = newUnselectionsArray ? newUnselectionsArray.length : 0;
        let newCredentialNum = existingCredentialNum + newSelectionsNum - newUnselectionsNum;
        if (newCredentialNum > omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber) {
          if (omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.credentialsCanBeAddedAfterCap === true) {
            //Check to see if all the new additions are massage credentials
            if (state.currentFilterResultsCredentialTypeName !== CREDENTIAL_TYPE_NAME_MASSAGE) {
              let existingNonMassageCredentialArray = omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.arrayData?.filter(x => (x.typeName !== CREDENTIAL_TYPE_NAME_MASSAGE));
              let existingNonMassageCredentialNum = existingNonMassageCredentialArray ? existingNonMassageCredentialArray.length : 0;
              let newNonMassageCredentialNum = existingNonMassageCredentialNum + newSelectionsNum - newUnselectionsNum;
              if (newNonMassageCredentialNum > omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber) {
                deckPassRuleError = true;
              }
            }
          }
          else {
            deckPassRuleError = true;
          }
        }
      }
      if (deckPassRuleError === true) {
        setErrors({ ...errorState, general: `The current selections exceed the number of allowed credentials according to the meet's deck pass rules. Only ${omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber ?? ''} credential ${omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber === 1 ? 'selection is' : 'selections are'} allowed. ${omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.credentialsCanBeAddedAfterCap === true ? 'Only massage credentials can be added after the cap has been reached.' : 'No credentials can be added after the cap has been reached.'}` });
      }
      else {
        if (selectionChangesState.arrayData.length > 0) {
          let allSelectionsInGoodStanding = true;
          for (let i = 0; i < selectionChangesState.arrayData.length; i++) {
            if (selectionChangesState.arrayData[i].isInGoodStanding === false && selectionChangesState.arrayData[i].isSelected === true) {
              allSelectionsInGoodStanding = false
            }
          }
          if (allSelectionsInGoodStanding === true) {
            postOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.orgUnitAthleteEntryId, {
              maxCredentialNumber: omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber,
              members: selectionChangesState.arrayData
            },
              state.currentFilterResultsCredentialTypeId);
            setState({ ...state, tryRedirect: true });
          }
          else {
            setErrors({ ...errorState, general: "All selections must be 'In Good Standing'. At least one selection is 'Not In Good Standing', which is not allowed." })
          }
        }
        else {
          setState({ ...state, tryRedirect: true });
        }
      }
    }
  }

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.ATHLETE_CREDENTIALS);
    }
    else {
      //Meet Route
      navigate(NavLinks.ATHLETE_CREDENTIALS);
    }
  }

  const onCheckboxChange = (e, personId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const updatedArrayData = JSON.parse(JSON.stringify(selectionChangesState.arrayData));
    const selectedAthleteIndexArrayData = updatedArrayData.findIndex(x => x.personId === personId);

    const updatedGridData = JSON.parse(JSON.stringify(gridState.gridData));
    const selectedAthleteIndexGridData = gridState.gridData?.findIndex(x => x.personId === personId);

    if (selectedAthleteIndexArrayData > -1) {
      updatedArrayData[selectedAthleteIndexArrayData].isSelected = !updatedArrayData[selectedAthleteIndexArrayData].isSelected;
      setSelectionChangesState({
        ...selectionChangesState,
        arrayData: updatedArrayData
      });
    }

    if (selectedAthleteIndexGridData > -1) {
      updatedGridData[selectedAthleteIndexGridData].isSelected = !updatedGridData[selectedAthleteIndexGridData].isSelected;
      setGridState({
        ...gridState,
        gridData: updatedGridData
      });
    }
    if (selectedAthleteIndexArrayData === -1) {
      const newAthlete = JSON.parse(JSON.stringify(updatedGridData[selectedAthleteIndexGridData]));
      updatedArrayData.push(newAthlete);
      setSelectionChangesState({
        ...selectionChangesState,
        arrayData: updatedArrayData
      });
    }
  };

  function submitFormCallback(formState) {
    if (state.currentFilterResultsCredentialTypeId !== formState.credentialTypeId) {
      setSelectionChangesState({ ...selectionChangesState, arrayData: [] });
    }
    setState({ ...state, currentFilterResultsCredentialTypeId: formState.credentialTypeId, currentFilterResultsCredentialTypeName: formState.credentialTypeName });
    getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.orgUnitAthleteEntryId, createFilterObj(formState));
  }

  function createFilterObj(formState) {
    return {
      credentialTypeId: formState.credentialTypeId !== Constants.DEFAULT_ID ? formState.credentialTypeId : undefined,
      isInGoodStanding: formState.isInGoodStanding ?? undefined,
      firstName: formState.firstOrPreferredName.trim() !== '' ? formState.firstOrPreferredName.trim() : undefined,
      lastName: formState.lastName.trim() !== '' ? formState.lastName.trim() : undefined,
      memberId: formState.memberId.trim() !== '' ? formState.memberId.trim() : undefined,
      email: formState.email.trim() !== '' ? formState.email.trim() : undefined
    }
  }

  function selectionsHaveBeenSaved() {
    //see if selection changes have been saved
    if (selectionChangesState.arrayData.length > 0) {
      return false;
    }

    return true;
  }

  useEffect(() => {
    const isSaved = selectionsHaveBeenSaved();
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: isSaved });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionChangesState.arrayData]);

  useEffect(() => {
    clearOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionArrayData();
    setState({ ...state, initialStateHandled: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (environmentVariableState.isLoaded === true, credentialTypeState.isArrayLoading === false &&
      credentialTypeState.isArrayLoaded === true && formState.credentialTypeId === Constants.DEFAULT_ID &&
      state.isInitialLoadComplete === false) {
      setFormState({
        ...formState,
        credentialTypeId: credentialTypeState.dataAsOptionsWithNames[1]?.id || Constants.DEFAULT_ID,
        credentialTypeName: credentialTypeState.dataAsOptionsWithNames[1]?.name || '',
        massageTypeName: CREDENTIAL_TYPE_NAME_MASSAGE || ''
      });
      setState({ ...state, initialStateHandled: true, isInitialLoadComplete: true, tryFilter: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environmentVariableState, credentialTypeState, formState.credentialTypeId, state.isInitialLoadComplete])


  useEffect(() => {
    if (omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isObjLoaded === true && omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData?.orgUnitAthleteEntryId &&
      state.tryFilter === true) {
      setState({ ...state, tryFilter: false, currentFilterResultsCredentialTypeId: formState.credentialTypeId, currentFilterResultsCredentialTypeName: formState.credentialTypeName });
      getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelection(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.orgUnitAthleteEntryId, createFilterObj(formState));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, state.tryFilter])

  useEffect(() => {
    if (state.initialStateHandled === true && omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.isArrayLoaded === true && omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.isArrayLoading === false) {
      const arrayDataCopy = JSON.parse(JSON.stringify(omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.members || []));
      //keep unsaved selections / unselections from previous searches
      if (selectionChangesState.arrayData.length > 0) {
        for (let i = 0; i < selectionChangesState.arrayData.length; i++) {
          const matchingIndex = arrayDataCopy.findIndex(x => x.personId === selectionChangesState.arrayData[i].personId);
          if (matchingIndex > -1) {
            arrayDataCopy[matchingIndex].isSelected = selectionChangesState.arrayData[i].isSelected;
          }
        }
      }
      setGridState({ ...gridState, gridData: arrayDataCopy });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.initialStateHandled, omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.isArrayLoaded, omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.isArrayLoading])

  useEffect(() => {
    if (state.tryRedirect === true && omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.isSaving === false &&
      omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.isSaved === true) {
      if (omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.objData?.success === true) {
        if (omeMeetState.route === '') {
          //OME Route
          navigate(EntryNavLinks.ATHLETE_CREDENTIALS, { state: { tryGet: selectionChangesState.arrayData.length > 0 ? true : false } });
        }
        else {
          //Meet Route
          navigate(NavLinks.ATHLETE_CREDENTIALS, { state: { tryGet: selectionChangesState.arrayData.length > 0 ? true : false } });
        }
      }
      else {
        setErrors({ ...errorState, general: `The current selections exceed the number of allowed credentials according to the meet's deck pass rules. Currently, ${omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber ?? ''} credential ${omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.maxCredentialNumber === 1 ? 'selection is' : 'selections are'} allowed. ${omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState.arrayData?.credentialsCanBeAddedAfterCap === true ? 'Only massage credentials can be added after the cap has been reached.' : 'No credentials can be added after the cap has been reached.'}` });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryRedirect, omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState])

  return {
    gridState,
    omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentialsSelectionState,
    onSaveClicked,
    onBackClicked,
    onCheckboxChange,
    onFilterClicked,
    onClearFilterClicked,
    onFormValueChanged,
    onValueTextPairChanged,
    formState,
    errorState
  };
}

export default useAthleteUserCredentialsSelection;